import {defineMessages, FormattedMessage} from 'react-intl';
import {view} from '@sail/ui';
import {MetaRow} from './MetaRow';

const messages = defineMessages({
  participantLeft: {
    id: 'conversations_ui.chat.row.participantLeft',
    description: 'Message to show as in a conversation when someone leaves.',
    defaultMessage: '{name} has left.',
  },
});

type Props = {
  name: string;
  MetaRowComponent?: typeof MetaRow;
};

export const LeaveRow = ({name, MetaRowComponent = MetaRow}: Props) => (
  <view.div data-testid="leave-row">
    <MetaRowComponent>
      <FormattedMessage {...messages.participantLeft} values={{name}} />
    </MetaRowComponent>
  </view.div>
);
